import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'
import { Typography } from '../typography'

interface IStyledValueProps {
  selected: boolean
}

export const StyledWrapper = styled.div`
  display: flex;
  width: fit-content;
  padding: 2px;
  background-color: ${baseTheme.colors.greySoft};
  border-radius: 8px;
  border: 1px solid ${baseTheme.colors.lightGrey};
  width: 100%;
`

export const StyledValue = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px 6px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 8px;
  background-color: ${(props: IStyledValueProps) => (props.selected ? baseTheme.colors.lightGrey : 'none')};
  color: ${(props: IStyledValueProps) => (props.selected ? `red` : `white`)};
  transition: background-color 0.5s, color 0.5s, border 1s;
  white-space: nowrap;
  width: 50%;

  ${Typography} {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${(props: IStyledValueProps) => (props.selected ? '#343039' : '#B3B3B3')};
  }
`
